/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UICustomizationChallengeOptions } from './UICustomizationChallengeOptions';
import {
    UICustomizationChallengeOptionsFromJSON,
    UICustomizationChallengeOptionsFromJSONTyped,
    UICustomizationChallengeOptionsToJSON,
} from './UICustomizationChallengeOptions';

/**
 * 
 * @export
 * @interface UICustomizationChallengeAllOf
 */
export interface UICustomizationChallengeAllOf {
    /**
     * 
     * @type {UICustomizationChallengeOptions}
     * @memberof UICustomizationChallengeAllOf
     */
    options?: UICustomizationChallengeOptions;
}

/**
 * Check if a given object implements the UICustomizationChallengeAllOf interface.
 */
export function instanceOfUICustomizationChallengeAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UICustomizationChallengeAllOfFromJSON(json: any): UICustomizationChallengeAllOf {
    return UICustomizationChallengeAllOfFromJSONTyped(json, false);
}

export function UICustomizationChallengeAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): UICustomizationChallengeAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'options': !exists(json, 'options') ? undefined : UICustomizationChallengeOptionsFromJSON(json['options']),
    };
}

export function UICustomizationChallengeAllOfToJSON(value?: UICustomizationChallengeAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'options': UICustomizationChallengeOptionsToJSON(value.options),
    };
}

